export default "__VITE_ASSET__XWyznDRD__"